import { useLocation } from "react-router-dom";

// Routes where the public marketing trust badge should NOT appear.
const HIDDEN_PREFIXES = ["/user", "/admin"];

/**
 * Mounts the TrustsAdvisor certificate badge only on public pages.
 *
 * The widget script (https://api.trustsadvisor.com/widget.js, loaded in
 * index.html) scans for `.trust-advisor-widget` and renders the badge into it.
 * It also runs a MutationObserver, so when this div mounts on a public route the
 * badge appears, and when we navigate into /user or /admin React unmounts the
 * div and the badge disappears.
 *
 * The certificate badge renders as position:absolute (bottom/right) inside this
 * div, so the div is anchored to the bottom-right corner as a zero-size fixed
 * box (widget.js sets overflow:visible on it).
 */
export default function TrustAdvisorWidget() {
  const { pathname } = useLocation();

  const hidden = HIDDEN_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );

  if (hidden) return null;

  return (
    <div
      className="trust-advisor-widget"
      data-domain="urfx.io"
      data-theme="dark"
      data-type="trust-certificate"
      data-position="bottom-right"
      style={{ position: "fixed", bottom: 0, right: 0, zIndex: 9999 }}
    />
  );
}
